import { baseURL } from '../apiService/apiService'

export const toPlans = (plans) => {
    return plans.map((q) => toPlan(q))
}
export const toPlan = (plan) => ({
    ...plan,
    fullName: plan.authorFullName,
    imageUrl: baseURL + plan.thumbnail,
    isLiked: plan.isLiked,
    isFavourited: plan.isMarked,
    isPublic: plan.isPublic,
    showToggle: plan.isOwner,
})
export const toComments = (comments) => {
    return comments.map((q) => toComment(q))
}
export const toComment = (comment) => ({
    ...comment,
    id: comment.id,
    name: comment.authorFullName,
    userImageUrl: comment.authorProfilePhoto,
    time: new Date(comment.addedDate),
    modificationDate: new Date(comment.modificationDate),
    text: comment.text,
})
export const toPlanProfile = (profile) => ({
    fullName: profile.authorFullName,
    image: profile.authorProfilePicture,
    PlanCount: profile.authorTotalPostCount ?? '-',
    RegistrationDate: new Date(profile.addedDate),
    rankCurrentMonth:
        profile.authorCurrentMonthRank == 0
            ? '-'
            : profile.authorCurrentMonthRank,
    rankTotal: profile.authorTotalRank == 0 ? '-' : profile.authorTotalRank,
})
export const toUserProfile = (profile) => {
    let date = new Date(profile.registerationDate)

    if (date.getFullYear() < 100) date = new Date(2021, 1, 1)

    return {
        fullName: `${profile.firstName} ${profile.lastName}`,
        PlanCount: profile.postsCount ?? '-',
        RegistrationDate: date,
        rankCurrentMonth:
            profile.rankInCurrentMonth == 0 ? '-' : profile.rankInCurrentMonth,
        rankTotal: profile.totalRank == 0 ? '-' : profile.totalRank,
    }
}
export const toFabrics = (fabrics) => {
    if (!fabrics) return []
    if (typeof fabrics !== 'string') return []

    return fabrics.split(',').map((q) => ({ id: q }))
}
export const toFabric = (fabric) => ({
    ...fabric,
    //name: fabric.title,
    //imageUrl: fabric.thumbnail,
    price: parseInt(fabric.price) ,
    discount: fabric.offPrice,
    meterage: 1,
})
export const toFilters = (filters) => {
    return filters.map((q) => toFilter(q))
}
export const toFilter = (filter) => ({
    ...filter,
    id: filter.id,
    title: filter.id,
    displayTitle: filter.title,
    type: 'checkbox',
    items: filter?.options?.split(',') ?? [],
})
